var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c('v-layout',{staticClass:"printable"},[_c(_vm.component,_vm._b({tag:"component",on:{"readyToPrint":_vm.print,"cancelPrint":_vm.cancel}},'component',_vm.props,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }